import { useContext } from 'react';
import FieldContext from '../../FieldContext';
import StyledFieldWrapper from './StyledFieldWrapper';
import FieldName from '../utils/FieldName';
import InnerSelect from './InnerSelect';
import useIsPortfolioReadonly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';

const SelectField = () => {
  const portfolioIsReadonly = useIsPortfolioReadonly();

  const field = useContext(FieldContext);
  const options = Object.entries(field.additionalConfig.options ?? {});

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <StyledFieldWrapper>
      <FieldName />
      <InnerSelect disabled={portfolioIsReadonly} />
    </StyledFieldWrapper>
  );
};

export default SelectField;
